import React from "react";
import { Routers } from "./routers/routers";
import { GlobalStyles } from "./reset.css";

function App() {
  return (
    <>
      <GlobalStyles />
      <Routers />
    </>
  );
}

export default App;
